import axios, { AxiosResponse } from "axios";
import { Component, Vue } from "vue-property-decorator";

@Component
export class DashboardHttp extends Vue {
	public getCountWidgetData(): Promise<AxiosResponse<any>> {
		return axios.get(process.env.VUE_APP_API_ENDPOINT + "/dashboard/counts", {
			headers: {
				authorization: "Bearer " + localStorage.getItem("access_token"),
			},
		});
	}
}
